var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "btn-box" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.addcate } },
              [_vm._v(_vm._s(_vm.$t("hr.addcategorys")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-box mt10" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "header-cell-style": {
                    background: "#F2F2F2",
                    color: "black",
                  },
                  "tree-props": {
                    children: "children",
                    hasChildren: "hasChildren",
                  },
                  border: "",
                  "default-expand-all": "",
                  "row-key": "id",
                },
              },
              [
                _c("el-table-column", {
                  staticStyle: { "padding-left": "20px" },
                  attrs: { label: "ID", "min-width": "80", prop: "id" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("hr.rankcategoryname"),
                    "min-width": "180",
                    prop: "name",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("hr.ranknumber"),
                    "min-width": "180",
                    prop: "number",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("hr.prerankcategories"),
                    "min-width": "180",
                    prop: "cate.name",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("public.operation"),
                    flxed: "right",
                    prop: "address",
                    width: "160",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.edit(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("public.edit")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.delet(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("public.delete")))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }